export default __webpack_public_path__ + "static/media/404_notfound.0da4a9c9.png";